"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldPhone = void 0;
const react_1 = __importDefault(require("react"));
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Wrapper_1 = require("../Wrapper");
require("react-phone-input-2/lib/style.css");
require("./index.scss");
const className = 'form-field-phone';
const preferredCountries = ['sq', 'at', 'fr', 'de', 'it', 'xk', 'mk', 'ch'];
const customMasksForPreferredCountries = {
    sq: '.........',
    at: '...............',
    fr: '. .. .. .. ..',
    de: '.............',
    it: '...........',
    xk: '.. ... ...',
    mk: '. .... ...',
    ch: '.. ... .. ..',
};
class FormFieldPhone extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value, data, event) => {
            value = (value && value[0] !== '+') ? '+' + value : value;
            this.props.onChange && this.props.onChange({ ...event, target: { ...event.target, value } }, data);
        };
        this.handleOnMount = (value, data) => {
            this.props.onMount && this.props.onMount(data);
        };
    }
    render() {
        const { country, error, label, value, onChange, onMount, modificators, ...otherProps } = this.props;
        // quickly fix the issue with fail https://mywork.xiag.ch/search#87005.
        const stringValue = !!value ? `${value}` : null;
        return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: label, error: error, modificators: modificators, additionClassNames: (0, classFunctions_1.getClassNames)(className, otherProps.disabled ? 'disabled' : undefined), inputSlot: react_1.default.createElement(react_phone_input_2_1.default, { preferredCountries: preferredCountries, masks: customMasksForPreferredCountries, country: country, value: stringValue, onChange: this.handleOnChange, onMount: this.handleOnMount, inputProps: otherProps, disableDropdown: otherProps.disabled }) }));
    }
}
exports.FormFieldPhone = FormFieldPhone;
FormFieldPhone.defaultProps = {
    error: undefined,
    label: undefined,
    onChange: () => { },
    onMount: () => { },
    value: '',
};
//# sourceMappingURL=index.js.map